/* NORDHOLZ Finder (Ida, 28.10.2026)
   Schritt-für-Schritt-Fragen mit Fortschritt und Zurück.
   Modi: "aufguss" (3 Fragen, Duftprofile) und "berater" (5 Fragen, ganzes Sortiment).
   Produkte und Preise kommen live aus /collections/<handle>/products.json. */
(function(){
  'use strict';
  var cache = {};
  function getCol(h){
    if (!cache[h]) cache[h] = fetch('/collections/' + h + '/products.json?limit=250')
      .then(function(r){ return r.ok ? r.json() : {products:[]}; })
      .then(function(j){ return j.products || []; })
      .catch(function(){ return []; });
    return cache[h];
  }
  function getCols(list){
    return Promise.all(list.map(getCol)).then(function(all){
      var seen = {}, out = [];
      all.forEach(function(ps){ ps.forEach(function(p){ if (!seen[p.id]) { seen[p.id] = 1; out.push(p); } }); });
      return out;
    });
  }
  function loadProfiles(url){
    if (window.NH_PROFILES || !url) return Promise.resolve();
    return new Promise(function(ok){ var s = document.createElement('script'); s.src = url; s.onload = ok; s.onerror = ok; document.head.appendChild(s); });
  }
  function eur(n){ return n.toFixed(2).replace('.', ',') + ' €'; }
  function esc(t){ return String(t).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function img(p, w){ var i = p.images && p.images[0] ? (p.images[0].src || p.images[0]) : ''; return i ? i + (i.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
  function sortKey(p){
    var m = String(p.title).match(/#\s*(\d+)/); if (!m) return null;
    var pre = /bio/i.test(p.product_type || '') ? 'b' : (/konzentrat/i.test(p.title) ? 'c' : 's');
    return pre + parseInt(m[1], 10);
  }
  function shortTitle(t){ return String(t).replace(/\s*\d+\s*ml.*$/i, '').replace(/^Sauna Aufguss Konzentrat\s*/i, 'Aufguss ').trim(); }
  function cheapest(p){
    var vs = (p.variants || []).filter(function(v){ return v.available !== false; }).sort(function(x, y){ return parseFloat(x.price) - parseFloat(y.price); });
    return vs.length ? {id:vs[0].id, t:vs[0].title, p:parseFloat(vs[0].price)} : null;
  }
  /* Aufguss: bevorzugt die 100-ml-Flasche, sonst die günstigste Größe */
  function prefVariant(p){
    var vs = (p.variants || []).filter(function(v){ return v.available !== false; });
    if (!vs.length) return null;
    var h = vs.filter(function(v){ return /100\s*ml/i.test(v.title); })[0];
    if (!h) h = vs.slice().sort(function(x, y){ return parseFloat(x.price) - parseFloat(y.price); })[0];
    return {v:{id:h.id, t:h.title, p:parseFloat(h.price)}, fit:2};
  }

  /* ---------- Fragen ---------- */
  var FAM = [
    {v:'minze,kraeuter', l:'Frisch und klar', h:'Minze, Eukalyptus, Kräuter'},
    {v:'wald', l:'Wald und Holz', h:'Fichte, Zirbe, Latschenkiefer'},
    {v:'zitrus,frucht,exotisch', l:'Fruchtig und sonnig', h:'Orange, Beeren, Kokos'},
    {v:'gourmand,winter', l:'Warm und gemütlich', h:'Zimt, Vanille, Honig'},
    {v:'blumig,edel', l:'Blumig und edel', h:'Lavendel, Rose, Sandelholz'}
  ];
  var MODES = {
    aufguss: [
      {id:'fam', t:'Welche Duftrichtung magst du?', o:FAM},
      {id:'mood', t:'Wann saunierst du am liebsten?', o:[
        {v:'energie,sport', l:'Morgens oder nach dem Sport', h:'Zum Wachwerden'},
        {v:'ruhe', l:'Abends', h:'Zum Runterkommen'},
        {v:'gemuetlich,urlaub,sinnlich', l:'Zu zweit oder mit Freunden', h:'Gemütlich und gesellig'},
        {v:'natur', l:'Am liebsten wie im Wald', h:'Natürlich und klar'}]},
      {id:'int', t:'Wie kräftig darf der Duft sein?', o:[
        {v:'2', l:'Sanft', h:'Dezent im Hintergrund'},
        {v:'3', l:'Mittel', h:'Deutlich, aber rund'},
        {v:'5', l:'Richtig kräftig', h:'Für Aufguss-Fans'}]}
    ],
    berater: [
      {id:'who', t:'Für wen suchst du etwas?', o:[
        {v:'me', l:'Für mich selbst', h:'Ich gönn mir was'},
        {v:'partner', l:'Partnerin oder Partner', h:'Für den Lieblingsmenschen'},
        {v:'family', l:'Eltern oder Familie', h:'Mama, Papa, Oma, Opa'},
        {v:'friends', l:'Freundin oder Freund', h:'Für gute Freunde'},
        {v:'work', l:'Kollegen oder Wichteln', h:'Büro, Verein, Freundeskreis'}]},
      {id:'where', t:'Wo wird sauniert?', o:[
        {v:'home', l:'In der eigenen Sauna', h:'Zuhause, im Garten, im Ferienhaus'},
        {v:'public', l:'In Therme oder Fitnessstudio', h:'Öffentliche Saunen'},
        {v:'ir', l:'In der Infrarotkabine', h:'Ohne klassischen Aufguss'},
        {v:'none', l:'Gar nicht, aber Wellness', h:'Baden, Entspannen, Duft'},
        {v:'unsure', l:'Weiß ich nicht genau', h:'Dann nehmen wir etwas, das immer passt'}]},
      {id:'cat', t:'Was darf es sein?', o:[
        {v:'duft', l:'Düfte', h:'Aufgüsse oder ätherische Öle', hide:['public','ir']},
        {v:'textil', l:'Zum Anziehen und Einkuscheln', h:'Saunahut, Kilt, Handtuch, Bademantel'},
        {v:'zubehoer', l:'Zubehör für die Sauna', h:'Eimer, Kelle, Thermometer, Kissen', hide:['none']},
        {v:'pflege', l:'Pflege nach dem Schwitzen', h:'Honig, Salz, Peeling'},
        {v:'set', l:'Ein fertiges Set', h:'Schön zusammengestellt'},
        {v:'surprise', l:'Überrasch mich', h:'Unsere Lieblinge'}]},
      {id:'fam', t:'Welche Duftrichtung passt?', o:FAM.concat([{v:'any', l:'Egal, Hauptsache gut', h:'Dann nehmen wir Klassiker'}]), when:function(a){ return a.cat === 'duft' && a.where !== 'none'; }},
      {id:'budget', t:'Wie viel möchtest du ausgeben?', o:[
        {v:'0-20', l:'Bis 20 €', h:'Kleine Aufmerksamkeit'},
        {v:'20-40', l:'20 bis 40 €', h:'Ein richtiges Geschenk'},
        {v:'40-70', l:'40 bis 70 €', h:'Darf Eindruck machen'},
        {v:'70-999', l:'Ab 70 €', h:'Etwas Besonderes'}]}
    ]
  };
  var WHO = {me:'für dich', partner:'für deinen Lieblingsmenschen', family:'für die Familie', friends:'für gute Freunde', work:'fürs Büro oder Wichteln'};
  var WHERE = {home:'Passt zur eigenen Sauna zuhause', public:'Auch für Therme und Fitnessstudio', ir:'Funktioniert ganz ohne Aufguss', none:'Wellness auch ohne Sauna', unsure:'Passt zu fast jedem Saunafan'};

  function berCollections(a){
    var c = a.cat, w = a.where;
    if (c === 'duft') return w === 'none' ? ['atherische-ole-fur-diffuser'] : ['sauna-aufguss', 'bio-saunaufguss', 'probierbox', 'aufguss-konfigurator'];
    if (c === 'textil') return ['saunahut', 'kilts', 'handtucher', 'bademantel', 'sets'];
    if (c === 'zubehoer') return (w === 'public' || w === 'ir') ? ['sauna-kissen', 'ruckenlehne-kopfstutze'] : ['sauna-eimer-sets', 'sauna-messgerat', 'sauna-kissen', 'ruckenlehne-kopfstutze'];
    if (c === 'pflege') return ['sauna-honig', 'sauna-salz', 'peelings', 'geschenk-bundle-korperpflege'];
    if (c === 'set') return (w === 'home' || w === 'unsure') ? ['saunaaufguss-bundels', 'probierbox', 'sets', 'geschenk-bundle-korperpflege', 'discovery-box'] : ['sets', 'geschenk-bundle-korperpflege'];
    return (w === 'home' || w === 'unsure') ? ['bestseller'] : ['saunahut', 'sauna-honig', 'sauna-kissen', 'handtucher'];
  }
  var EXTRA = {duft:'sauna-extras', textil:'probierbox', zubehoer:'probierbox', pflege:'handtucher'};

  /* Variante im Budget wählen */
  function pickVariant(p, lo, hi){
    var vs = (p.variants || []).filter(function(v){ return v.available !== false; })
      .map(function(v){ return {id:v.id, t:v.title, p:parseFloat(v.price)}; });
    if (!vs.length) return null;
    var inR = vs.filter(function(v){ return v.p >= lo && v.p <= hi; }).sort(function(x, y){ return y.p - x.p; });
    if (inR.length) return {v:inR[0], fit:2};
    var below = vs.filter(function(v){ return v.p < lo; }).sort(function(x, y){ return y.p - x.p; });
    if (below.length) return {v:below[0], fit:1};
    return null;
  }

  function rankAufguss(list, fams, moods, inten){
    var P = window.NH_PROFILES && window.NH_PROFILES.products || {};
    return list.map(function(p){
      var k = sortKey(p), pr = k && P[k], s = 0;
      if (!pr) return null;
      if (fams && fams.indexOf(pr.fam) > -1) s += 4;
      if (moods && pr.moods.some(function(m){ return moods.indexOf(m) > -1; })) s += 2;
      if (inten) s -= Math.abs((pr.d[3] || 3) - inten) * 0.8;
      return {p:p, s:s, pr:pr};
    }).filter(Boolean).sort(function(a, b){ return b.s - a.s; });
  }

  /* Alternativen: möglichst verschiedene Produktarten zeigen */
  function alts(list, top){
    function k(x){ return shortTitle(x.p.title).toLowerCase().split(/\s+/).slice(0, 2).join(' '); }
    var used = {}, out = [];
    used[k(top)] = 1;
    list.slice(1).forEach(function(x){ if (out.length < 3 && !used[k(x)]) { used[k(x)] = 1; out.push(x); } });
    list.slice(1).forEach(function(x){ if (out.length < 3 && out.indexOf(x) < 0) out.push(x); });
    return out;
  }

  /* ---------- UI ---------- */
  function Finder(el){
    this.el = el; this.mode = el.getAttribute('data-mode') || 'aufguss';
    this.qs = MODES[this.mode]; this.a = {}; this.step = 0;
    this.profiles = el.getAttribute('data-profiles');
    this.body = el.querySelector('[data-nf-body]');
    var self = this;
    el.addEventListener('click', function(e){
      var o = e.target.closest('[data-nf-opt]'); if (o) { self.answer(o.getAttribute('data-nf-opt')); return; }
      if (e.target.closest('[data-nf-back]')) { self.back(); return; }
      if (e.target.closest('[data-nf-restart]')) { self.a = {}; self.step = 0; self.render(); return; }
      var add = e.target.closest('[data-nf-add]'); if (add) { e.preventDefault(); self.addToCart(add); }
    });
    loadProfiles(this.profiles);
    this.render();
  }
  Finder.prototype.visible = function(){
    var a = this.a; return this.qs.filter(function(q){ return !q.when || q.when(a); });
  };
  Finder.prototype.answer = function(v){
    var qs = this.visible(), q = qs[this.step]; this.a[q.id] = v;
    if (q.id === 'where' && this.a.cat) delete this.a.cat;
    qs = this.visible();
    if (this.step < qs.length - 1) { this.step++; this.render(); } else { this.result(); }
  };
  Finder.prototype.back = function(){ if (this.step > 0) { this.step--; this.render(); } };
  Finder.prototype.render = function(){
    var qs = this.visible(), q = qs[this.step], a = this.a, n = qs.length;
    var h = '<div class="nf-top">' + (this.step > 0 ? '<button type="button" class="nf-back" data-nf-back>‹ Zurück</button>' : '<span></span>') +
      '<span class="nf-count">Frage ' + (this.step + 1) + ' von ' + n + '</span></div>' +
      '<div class="nf-bar"><i style="width:' + Math.round((this.step + 1) / n * 100) + '%"></i></div>' +
      '<h3 class="nf-q">' + q.t + '</h3><div class="nf-opts">';
    q.o.forEach(function(o){
      if (o.hide && o.hide.indexOf(a.where) > -1) return;
      h += '<button type="button" class="nf-opt' + (a[q.id] === o.v ? ' is-on' : '') + '" data-nf-opt="' + o.v + '"><b>' + o.l + '</b>' + (o.h ? '<span>' + o.h + '</span>' : '') + '</button>';
    });
    this.body.innerHTML = h + '</div>';
  };
  Finder.prototype.loading = function(){ this.body.innerHTML = '<div class="nf-load">Einen Moment, wir suchen passende Produkte …</div>'; };
  Finder.prototype.result = function(){
    var self = this; this.loading();
    (this.mode === 'aufguss' ? this.resAufguss() : this.resBerater()).catch(function(){
      self.body.innerHTML = '<div class="nf-load">Gerade konnten wir keine Produkte laden. <a href="/collections/sauna-aufguss">Zu den Saunaaufgüssen ›</a></div>';
    });
  };
  Finder.prototype.card = function(p, v, note){
    return '<a class="nf-alt" href="/products/' + p.handle + '">' + (img(p, 200) ? '<img src="' + img(p, 200) + '" alt="' + esc(shortTitle(p.title)) + '" loading="lazy" width="72" height="72">' : '<span class="nf-ph"></span>') +
      '<span><b>' + esc(shortTitle(p.title)) + '</b>' + (note ? '<em>' + esc(note) + '</em>' : '') + '<i>' + (v ? eur(v.p) : '') + '</i></span></a>';
  };
  Finder.prototype.main = function(p, v, label, reasons, extra){
    var h = '<div class="nf-res"><div class="nf-ey">' + label + '</div><div class="nf-hero">' +
      (img(p, 600) ? '<img src="' + img(p, 600) + '" alt="' + esc(shortTitle(p.title)) + '" width="260" height="260">' : '') +
      '<div><h3>' + esc(shortTitle(p.title)) + '</h3><ul class="nf-why">';
    reasons.forEach(function(r){ if (r) h += '<li>' + esc(r) + '</li>'; });
    h += '</ul><div class="nf-price">' + eur(v.v.p) + (v.v.t && v.v.t !== 'Default Title' ? ' <small>' + esc(v.v.t) + '</small>' : '') + '</div>' +
      '<div class="nf-ctas"><button type="button" class="nf-btn" data-nf-add="' + v.v.id + '">In den Warenkorb</button><a class="nf-link" href="/products/' + p.handle + '">Details ansehen ›</a></div>' +
      (extra || '') + '</div></div>';
    return h;
  };
  Finder.prototype.foot = function(more){
    return more + '<div class="nf-again"><button type="button" class="nf-link" data-nf-restart>Nochmal starten</button></div></div>';
  };
  Finder.prototype.resAufguss = function(){
    var self = this, a = this.a;
    return loadProfiles(this.profiles).then(function(){ return getCols(['sauna-aufguss', 'bio-saunaufguss']); }).then(function(list){
      var r = rankAufguss(list, a.fam.split(','), a.mood.split(','), parseInt(a.int, 10)).filter(function(x){ return prefVariant(x.p); });
      if (!r.length) throw 0;
      var top = r[0], tv = prefVariant(top.p);
      var famL = FAM.filter(function(f){ return f.v === a.fam; })[0];
      var h = self.main(top.p, tv, 'Dein Aufguss', [top.pr.tag, 'Duftnoten: ' + top.pr.notes.join(', '), famL ? 'Richtung: ' + famL.l : '']);
      var more = '<div class="nf-ey nf-mt">Passt auch zu dir</div><div class="nf-alts">';
      r.slice(1, 4).forEach(function(x){ more += self.card(x.p, prefVariant(x.p).v, x.pr.tag); });
      more += '</div><p class="nf-hint">Alle Düfte erklärt und dein eigenes Set: <a href="/pages/aufguss-lexikon#nh-finder">Aufguss-Lexikon ›</a></p>';
      self.body.innerHTML = self.foot(h + more);
    });
  };
  Finder.prototype.resBerater = function(){
    var self = this, a = this.a, b = a.budget.split('-'), lo = +b[0], hi = +b[1];
    var cols = berCollections(a);
    return loadProfiles(this.profiles).then(function(){ return getCols(cols); }).then(function(list){
      var c = list.map(function(p){ var pv = pickVariant(p, lo, hi); return pv ? {p:p, pv:pv, s:pv.fit * 10} : null; }).filter(Boolean);
      if (a.cat === 'duft' && a.where !== 'none' && a.fam && a.fam !== 'any') {
        var P = window.NH_PROFILES && window.NH_PROFILES.products || {}, fams = a.fam.split(',');
        c.forEach(function(x){ var k = sortKey(x.p), pr = k && P[k]; x.pr = pr; if (pr && fams.indexOf(pr.fam) > -1) x.s += 5; });
      }
      c.forEach(function(x, i){ x.s -= i * 0.01; });
      c.sort(function(x, y){ return y.s - x.s; });
      if (!c.length) throw 0;
      var top = c[0], reasons = [WHERE[a.where]];
      if (top.pr) { reasons.push(top.pr.tag); reasons.push('Duftnoten: ' + top.pr.notes.join(', ')); }
      reasons.push(top.pv.fit === 2 ? 'Liegt in deinem Budget' : 'Etwas günstiger als dein Budget');
      var extraP = EXTRA[a.cat] && !(a.cat === 'duft' && a.where === 'none') && !((a.where === 'public' || a.where === 'ir') && a.cat !== 'pflege') ? EXTRA[a.cat] : null;
      return (extraP ? getCol(extraP) : Promise.resolve([])).then(function(ex){
        var exP = ex.filter(function(p){ return p.id !== top.p.id && cheapest(p); })[0], extra = '';
        if (exP) { var ev = cheapest(exP); extra = '<div class="nf-plus"><span>Passt dazu</span>' + self.card(exP, ev, '') + '</div>'; }
        var h = self.main(top.p, top.pv, 'Unser Tipp ' + (WHO[a.who] || ''), reasons, extra);
        var more = '<div class="nf-ey nf-mt">Auch eine gute Idee</div><div class="nf-alts">';
        (top.pr ? c.slice(1, 4) : alts(c, top)).forEach(function(x){ more += self.card(x.p, x.pv.v, x.pr ? x.pr.tag : ''); });
        more += '</div><p class="nf-hint">Lieber auf Nummer sicher? <a href="/collections/e-gutschein">NORDHOLZ Gutschein ›</a></p>';
        self.body.innerHTML = self.foot(h + more);
      });
    });
  };
  Finder.prototype.addToCart = function(btn){
    var id = btn.getAttribute('data-nf-add'); btn.textContent = 'Wird hinzugefügt …';
    fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json', 'Accept':'application/json'}, body:JSON.stringify({items:[{id:+id, quantity:1}]})})
      .then(function(r){ if (!r.ok) throw 0; window.location.href = '/cart'; })
      .catch(function(){ btn.textContent = 'Bitte über Details bestellen'; });
  };

  function boot(){ document.querySelectorAll('[data-nh-finder]').forEach(function(el){ if (!el.__nf) el.__nf = new Finder(el); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
